import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LetDirective } from '@ngrx/component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { WebAnalyticsSettingsComponent } from './web-analytics-settings.component';
import { WebSettingsModule } from '@web/shared/components/web-settings/web-settings.module';
import { SpSwitchComponent } from '@ui/sp-switch';
import { GoogleSettingsComponent } from '@web/shared/components/web-analytics-settings/google-settings/google-settings.component';
import { PixelSettingsComponent } from '@web/shared/components/web-analytics-settings/pixel-settings/pixel-settings.component';

@NgModule({
    imports: [
        CommonModule,
        LetDirective,
        ReactiveFormsModule,
        TranslateModule,
        WebSettingsModule,
        SpSwitchComponent,
        WebAnalyticsSettingsComponent,
        GoogleSettingsComponent,
        PixelSettingsComponent,
    ],
    exports: [WebAnalyticsSettingsComponent],
})
export class WebAnalyticsSettingsModule {}
